<template>
  <v-menu
    :close-on-content-click="false"
    bottom
    close-delay="100"
    max-width="320px"
    min-width="320px"
    nudge-bottom="8px"
    offset-y
    open-delay="200"
    open-on-hover
    left
    v-model="value_"
  >
    <slot name="activator" slot="activator"></slot>
    <v-card flat>
      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon size="42" color="primary">mdi-account-circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title :class="loginName || 'grey--text'">{{loginName || '未命名'}}</v-list-tile-title>
            <v-list-tile-sub-title class="caption">{{loginId}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-tooltip bottom disabled>
              <v-btn @click="goCenter" color="primary" flat slot="activator" small>个人中心</v-btn>
              <!--<span>即将开放</span>-->
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-layout></v-layout>
      <v-container class="px-3 pt-0 pb-2">
        <!--<v-subheader>角色</v-subheader>-->
        <v-layout :wrap="showAllRole" align-center class="pb-3" v-if="roleList.length">
          <v-flex v-if="showAllRole" xs12>
            <v-chip
              :key="i"
              small
              v-for="(role, i) in roleList"
            >
              {{role.name}}
            </v-chip>
          </v-flex>
          <v-flex v-else>
            <v-chip small>
              {{roleList[0].name}}
            </v-chip>
            <span class="caption grey--text px-2" v-if="roleList.length > 1">等，共 {{roleList.length}} 个角色</span>
            <span
              @click="showAllRole = !showAllRole"
              class="primary--text caption px-2" style="cursor: pointer"
            >展开<v-icon color="primary" small>mdi-chevron-down</v-icon>
            </span>
          </v-flex>
          <!--<v-btn-->
          <!--@click="showAllRole = !showAllRole"-->
          <!--color="primary"-->
          <!--flat-->
          <!--small-->
          <!--v-if="roleList.length > 1 && !showAllRole"-->
          <!--&gt;-->
          <!--{{showAllRole ? '收起':'展开'}}-->
          <!--</v-btn>-->
          <v-flex class="text-xs-right mt-2" v-if="showAllRole" xs12>
            <v-btn
              @click="showAllRole = !showAllRole"
              color="primary"
              flat
              small
              v-if="roleList.length > 1"
            >
              {{showAllRole ? '收起':'展开'}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <!--<v-divider></v-divider>-->
      <!--<v-container>-->
      <!--<v-layout>-->
      <!--<v-flex xs12>-->
      <!--<v-select-->
      <!--:disabled="roleSelects.length <= 1"-->
      <!--:items="roleSelects"-->
      <!--hide-details-->
      <!--item-text="name"-->
      <!--item-value="id"-->
      <!--label="角色"-->
      <!--prepend-icon="person_pin"-->
      <!--v-model="role"-->
      <!--&gt;</v-select>-->
      <!--</v-flex>-->
      <!--</v-layout>-->
      <!--</v-container>-->
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="logoutLoading" @click="logout" color="grey" flat small>退出系统</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'

let LOGIN_PAGE_NAME = 'Login'
const {mapState} = createNamespacedHelpers('login')
export default {
  name: 'userMenu',
  components: {},
  props: ['value'],
  data: () => ({
    showAllRole: false,
    activate: false,
    logoutLoading: false,
    mouseleave: false,
    fav: true,
    message: false,
    // menu: false,
    hints: true
  }),
  computed: {
    ...mapState({
      loginName: state => state.name,
      loginId: state => state.id,
      self: state => state.self
    }),
    roleList () {
      return (this.self && this.self.roleList) || []
    },
    institutionName () {
      return this.$store.state.login.self.insName
    },
    value_: {
      get () {
        if (this.value === undefined) {
          return this.activate
        }
        else {
          return this.value
        }
      },
      set (val) {
        if (this.value === undefined) {
          this.activate = val
        }
        else {
          this.$emit('input', val)
        }
      }
    },
  },
  methods: {
    goCenter () {
      this.$router.push({
        name: 'PersonalCenter'
      })
    },
    async logout () {
      this.logoutLoading = true
      try {
        await this.$store.dispatch('login/logout')
        this.value_ = false
        this.$router.push({name: LOGIN_PAGE_NAME})
      }
      catch (e) {
        this.$store.dispatch('alert', {type: 'error', title: '登出时发生错误', message: e.message})
      }
      finally {
        this.logoutLoading = false
      }
    }
  }
}
</script>
